"use client";

import { useEffect } from "react";
import { getLenis } from "@/components/SmoothScrollProvider";

export default function useLockScroll(lock: boolean) {
  useEffect(() => {
    const lenis = getLenis();

    if (lock) {
      lenis?.stop();
      document.body.style.overflow = "hidden";
      document.body.setAttribute("data-scroll-locked", "true");
    } else {
      lenis?.start();
      document.body.style.overflow = "";
      document.body.removeAttribute("data-scroll-locked");
    }

    return () => {
      lenis?.start();
      document.body.style.overflow = "";
      document.body.removeAttribute("data-scroll-locked");
    };
  }, [lock]);
}
